import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/rayleigh/cdf';
import __var_2__ from '@stdlib/stats/base/dists/rayleigh/ctor';
import __var_3__ from '@stdlib/stats/base/dists/rayleigh/entropy';
import __var_4__ from '@stdlib/stats/base/dists/rayleigh/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/rayleigh/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/rayleigh/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/rayleigh/mean';
import __var_8__ from '@stdlib/stats/base/dists/rayleigh/median';
import __var_9__ from '@stdlib/stats/base/dists/rayleigh/mgf';
import __var_10__ from '@stdlib/stats/base/dists/rayleigh/mode';
import __var_11__ from '@stdlib/stats/base/dists/rayleigh/pdf';
import __var_12__ from '@stdlib/stats/base/dists/rayleigh/quantile';
import __var_13__ from '@stdlib/stats/base/dists/rayleigh/skewness';
import __var_14__ from '@stdlib/stats/base/dists/rayleigh/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace rayleigh
*/
var rayleigh = {};

/**
* @name cdf
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/cdf}
*/
setReadOnly( rayleigh, 'cdf', __var_1__);

/**
* @name Rayleigh
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/ctor}
*/
setReadOnly( rayleigh, 'Rayleigh', __var_2__);

/**
* @name entropy
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/entropy}
*/
setReadOnly( rayleigh, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/kurtosis}
*/
setReadOnly( rayleigh, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/logcdf}
*/
setReadOnly( rayleigh, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/logpdf}
*/
setReadOnly( rayleigh, 'logpdf', __var_6__);

/**
* @name mean
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/mean}
*/
setReadOnly( rayleigh, 'mean', __var_7__);

/**
* @name median
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/median}
*/
setReadOnly( rayleigh, 'median', __var_8__);

/**
* @name mgf
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/mgf}
*/
setReadOnly( rayleigh, 'mgf', __var_9__);

/**
* @name mode
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/mode}
*/
setReadOnly( rayleigh, 'mode', __var_10__);

/**
* @name pdf
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/pdf}
*/
setReadOnly( rayleigh, 'pdf', __var_11__);

/**
* @name quantile
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/quantile}
*/
setReadOnly( rayleigh, 'quantile', __var_12__);

/**
* @name skewness
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/skewness}
*/
setReadOnly( rayleigh, 'skewness', __var_13__);

/**
* @name variance
* @memberof rayleigh
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/rayleigh/variance}
*/
setReadOnly( rayleigh, 'variance', __var_14__);


// EXPORTS //
export default rayleigh;

export { __var_1__ as cdf, __var_2__ as Rayleigh, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as variance};